<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <b-modal ref="modal" title="船舶过滤" size="lg" no-close-on-backdrop
             @ok="ok($event)" @cancel="close()" @close="close()">
        <div class="vessel-filter-content">
            <div class="vessel-filter-line">
                <div class="vessel-filter-label">船舶类型：</div>
                <div class="vessel-filter-input">
                    <select class="form-control" v-model="filters.type">
                        <option value="all">全部</option>
                        <option value="ship">显示空船</option>
                        <option value="mobile">显示有联系电话的船</option>
                        <option value="ship,mobile">显示有联系电话的空船</option>
                        <option value="none">仅显示搜索结果</option>
                    </select>
                </div>
            </div>
            <div class="vessel-filter-line">
                <div class="vessel-filter-label">船舶载重吨：</div>
                <div class="vessel-filter-input vessel-filter-weights">
                    <div class="flex-1"><input class="form-control" v-model="filters.minWeight"/></div>
                    —
                    <div class="flex-1"><input class="form-control" v-model="filters.maxWeight"/></div>
                </div>
            </div>
            <div class="vessel-filter-line">
                <div class="vessel-filter-label">船位更新时间：</div>
                <div class="vessel-filter-input">
                    <select class="form-control" v-model="filters.within">
                        <option value="2">2小时</option>
                        <option value="24">24小时</option>
                        <option value="48">48小时</option>
                        <option value="72">72小时</option>
                        <option value="168">168小时</option>
                    </select>
                </div>
            </div>
            <div class="vessel-filter-line">
                <div class="vessel-filter-label">包含以下所有标签：</div>
                <div class="vessel-filter-input">
                    <multi-tags-selector :tags="tags" v-model="filters.include"></multi-tags-selector>
                </div>
            </div>
            <div class="vessel-filter-line">
                <div class="vessel-filter-label">不含以下任一标签：</div>
                <div class="vessel-filter-input">
                    <multi-tags-selector :tags="tags" v-model="filters.exclude"></multi-tags-selector>
                </div>
            </div>
        </div>
        <template v-slot:modal-footer="{ ok, cancel }">
            <div class="w-100 d-flex align-items-center justify-content-between m-0">
                <div>
                    <b-button class="m-1" variant="outline-danger" @click="clear()">清空筛选条件</b-button>
                </div>
                <div class="form-inline">
                    <b-button class="m-1" variant="outline-primary" @click="cancel()">取消</b-button>
                    <b-button class="m-1" variant="primary" @click="ok()">确定</b-button>
                </div>
            </div>
        </template>
    </b-modal>
</template>

<script>
    import * as MsgBox from "../utils/msgBox";
    import Tag from "../services/tag";
    import MultiTagsSelector from "./MultiTagsSelector";

    const defaultFilters = {
        type: "none",
        minWeight: null,
        maxWeight: null,
        within: "72",
        include: [],
        exclude: [],
    };

    export default {
        name: "VesselFilterDialog",
        components: {MultiTagsSelector},
        data() {
            return {
                filters: this.getDefault(),
                tags: [],
            };
        },
        computed: {
            includeOptions() {
                return this.tags.filter(t => !this.filters.include.find(x => x.id === t.id));
            },
        },
        methods: {
            getDefault() {
                return JSON.parse(JSON.stringify(defaultFilters));
            },
            async modal(filters) {
                this.tags = await Tag.list();
                this.filters = filters ? {
                    type: filters.type || defaultFilters.type,
                    minWeight: filters.minWeight || defaultFilters.minWeight,
                    maxWeight: filters.maxWeight || defaultFilters.maxWeight,
                    within: filters.within ? filters.within.toString() : defaultFilters.within,
                    include: (filters.include || defaultFilters.include).filter(x => this.tags.find(t => t.id === x)),
                    exclude: (filters.exclude || defaultFilters.exclude).filter(x => this.tags.find(t => t.id === x)),
                } : this.getDefault();
                return new Promise(resolve => {
                    this.resolve = resolve;
                    this.$refs.modal.show();
                });
            },
            close() {
                this.resolve && this.resolve();
            },
            getWeight(value) {
                return value && value.toString().trim().length > 0 ? +value : null;
            },
            async ok(e) {
                e.preventDefault();
                let minWeight = this.getWeight(this.filters.minWeight);
                let maxWeight = this.getWeight(this.filters.maxWeight);
                if (minWeight !== null && !Number.isFinite(minWeight)) {
                    return await MsgBox.alert(this, "请输入正确的最小船舶载重吨", {title: "错误"});
                }
                if (maxWeight !== null && !Number.isFinite(maxWeight)) {
                    return await MsgBox.alert(this, "请输入正确的最大船舶载重吨", {title: "错误"});
                }
                if (minWeight !== null && maxWeight !== null && minWeight > maxWeight) {
                    return await MsgBox.alert(this, "最小船舶载重吨不能大于最大船舶载重吨", {title: "错误"});
                }
                let filters = {
                    type: this.filters.type,
                    minWeight,
                    maxWeight,
                    within: +this.filters.within || 0,
                    include: this.filters.include.slice(),
                    exclude: this.filters.exclude.slice(),
                };
                setTimeout(() => this.onResult(filters));
            },
            async clear() {
                this.filters = this.getDefault();
            },
            onResult(filters) {
                this.resolve && this.resolve(filters);
                this.$refs.modal.hide();
            },
        },
    }
</script>

<style scoped>
    .vessel-filter-content > * + *,
    .vessel-filter-aliases > * + * {
        margin-top: 0.5rem;
    }

    .vessel-filter-line {
        display: flex;
        align-items: stretch;
    }

    .vessel-filter-label {
        text-align: right;
        min-width: 150px;
        margin-right: 0.5rem;
        line-height: calc(1.5em + 0.75rem + 2px);
    }

    .vessel-filter-input {
        flex: 1;
    }

    .vessel-filter-weights {
        display: flex;
        align-items: center;
    }
</style>
